<div class="flex-colum gap-6">
  <div class="row">
    <button (click)="openJsonEditor()">{{ label }}</button>
  </div>
  <nw-file-project-definitions-json-modal
    *ngIf="showJsonEditor"
    (close)="onJsonClose()"
    [jsonText]="currentJSON$ | async"
    (save)="save($event)"
  ></nw-file-project-definitions-json-modal>
</div>
